<template>
  <v-container fluid pt-0 grid-list-xl>
    <push-notifications-listing></push-notifications-listing>
  </v-container>
</template>
<script>
import Vue from "vue";
import PushNotificationsListing from "./PushNotificationsListing";

import FileUpload from "@/components/FileUpload/FileUpload";
import { mapGetters } from "vuex";

export default {
  mounted() {},
  components: {
    PushNotificationsListing,
    FileUpload
  },
  computed: {
  
  },
  data() {
    return {
      dialog: false,
      search: "",
      notification: {}
    };
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },
  methods: {
    newNotification(notification, dialog) {
      this.$store
        .dispatch("createNotification", notification)
        .then(res => {
          notification = {}; //clear data
          dialog = false; //close dialog
          this.$root.$emit(
            "showSnackBar",
            "Notificacion creada correctamente",
            "success"
          );
          //Reload notifications
          this.$store.dispatch("getNotifications");
        })
        .catch(res => {
          this.$root.$emit(
            "showSnackBar",
            "Error al crear la notificacion",
            "error"
          );
        });
    }
  }
};
</script>
